var map = {
	"./anastasya1.png": 62980,
	"./anastasya2.png": 86754,
	"./anastasya3.png": 12803,
	"./anastasya4.png": 9822,
	"./anastasya5.png": 52936,
	"./bg1.jpeg": 93129,
	"./bg2.jpeg": 56086,
	"./bg3.jpeg": 90360,
	"./bg4.jpeg": 33275,
	"./brasov.jpeg": 35560,
	"./bucharest.jpeg": 83152,
	"./cluj-napoca.jpeg": 41633,
	"./comingSoon.jpeg": 73934,
	"./constanta.jpeg": 31263,
	"./flags/en.svg": 34063,
	"./flags/ro.svg": 30258,
	"./icons/discord.svg": 8028,
	"./icons/tiktok.svg": 65519,
	"./landingDevelopment.jpeg": 68326,
	"./logoBgPurple.png": 43407,
	"./marker/marker.png": 1268,
	"./owlearningWhite.png": 89281,
	"./register.jpeg": 32658,
	"./subscriptions.jpeg": 42180,
	"./vforce/logoBlack.png": 81255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;